package com.example.mystybag.url.model

data class URLViewUIState(
    var url     : String = "",
    var title   : String = "",
    var postBody: String = "",
    var successUrlPrefix: String = "",
    var cancelUrlPrefix: String = "",
    var transactionReference: String = "",
    var reservationId: Long = 0L,
    /** Native footer on payment success (wrapper success page); opens reservations (active tab). */
    var showPaymentSuccessFooter: Boolean = false
)